import React, { FC } from 'react';

import {
  Container,
  LoadingText,
  LogoWrapper,
  SubText,
  ProgressRing,
  Logo,
} from './LoaderStyle';

export interface LoaderProps {
  text?: string; // kept for backward compatibility but unused
  subText?: string; // backward compatibility
  src?: string;
}

const Loader: FC<LoaderProps> = ({
  src = '/static/icons/logo.svg',
  text = '',
  subText = '',
}) => (
  <Container>
    <LogoWrapper>
      <ProgressRing viewBox='0 0 180 180'>
        <circle className='ring-track' cx='90' cy='90' r='84' />
        <circle className='ring-progress' cx='90' cy='90' r='84' />
      </ProgressRing>
      <Logo alt='loader' src={src} />
    </LogoWrapper>
    {text && <LoadingText>{text}</LoadingText>}
    {subText && <SubText>{subText}</SubText>}
  </Container>
);

export default Loader;
